'use client';

import { useCart } from '../context';

export function useCartSheet() {
  const { cart, open, setOpen } = useCart();

  return {
    cart,
    open,
    setOpen,
    cartItemsCount: cart?.totalQuantity || 0,
    hasCartItems: (cart?.totalQuantity || 0) > 0,
  };
}
